module.exports = __webpack_public_path__ + "static/media/05.d8dd645a.png";